/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import {
  Box,
  Stack,
} from '@mui/material';
import {
  Card, ProfileCardContent, LabelAndValueElement, ContextMenuComplete, formatTimeWithTimeZoneName, useCurrentTime, ZAvatar,
} from '@marageti/z4-lib';
import { ProfileCardProps } from './types';
import styles from './styles';
import { getPhoneNumber, getAgentRoles } from '../../../utils/helpers';

const ProfileCard = ({
  agent,
  contextMenuProps,
  onEditAvatar,
}: ProfileCardProps) => {
  const [time] = useCurrentTime(agent?.timeZone?.name);

  return (
    <Card sx={styles.profileCard}>
      <ProfileCardContent>
        <Box sx={styles.avatarBoxDesktop}>
          <ZAvatar
            name={agent?.fullName}
            size={128}
            loading={!agent}
            src={agent?.avatar}
            onEdit={onEditAvatar}
          />
        </Box>
        <Stack spacing="24px" width="100%">
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <LabelAndValueElement
              title="Name"
              value={agent?.fullName}
              key="name"
            />
            <ContextMenuComplete {...contextMenuProps} />
          </Stack>
          <LabelAndValueElement
            title="Title"
            value={agent?.title || '-'}
            key="title"
          />
          <LabelAndValueElement
            title="Role"
            value={agent && getAgentRoles(agent)}
            key="role"
          />
          <LabelAndValueElement
            title="Timezone"
            value={agent?.timeZone ? formatTimeWithTimeZoneName(agent?.timeZone, time) : '-'}
            key="timeZone"
          />
          <LabelAndValueElement
            title="Phone"
            value={getPhoneNumber(agent)}
            key="phone"
          />
          <LabelAndValueElement
            title="Email"
            value={agent?.email}
            key="email"
          />
        </Stack>
      </ProfileCardContent>
    </Card>
  );
};

export default ProfileCard;
